// extracted by mini-css-extract-plugin
module.exports = {"DurationOptionsGrid":"appointments__DurationOptions__DurationOptionsGrid"};